import { IInspectionHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useInspection = (id: string | undefined): IInspectionHook => {
  const { inspectionStore } = useStore();
  const { inspection, loading } = inspectionStore;

  useEffect(() => {
    id && inspectionStore.get({ id });

    return () => inspectionStore.clearInspection();
  }, [inspectionStore, id]);

  return { loading, inspection };
};
